/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from '@/application';
import { getAgent } from './agent';
import { ICreateTransactionArgs } from '@services/tokenization-service/components';

const is = require('is_js');

export class TokenizationService {
  private static instance: TokenizationService;
  private vapp: VApplication;
  private readonly uploadAPI: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.uploadAPI = props?.uploadAPI;
  }

  public static getInstance(props: any = {}): TokenizationService {
    if (!TokenizationService.instance) {
      TokenizationService.instance = new TokenizationService(props);
    }
    return TokenizationService.instance;
  }

  public getAgent() {
    return getAgent();
  }

  public createTxn(args: ICreateTransactionArgs) {
    return getAgent().createTxn(args);
  }
}
